var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quill-custom",class:{ 'no-settings': _vm.noSettings }},[_c('div',{staticClass:"simple-editor shadow-soft border rounded-lg"},[_c('div',{ref:"editorNode",staticClass:"editor-node"})])])}
var staticRenderFns = []

export { render, staticRenderFns }